import Button from '@mui/material/Button';
import { createRadio, fetchRadioLookup } from '@sophocles/entities/Radio';
import { Map } from 'immutable';
import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';

const buttonStyle = { height: '31px', lineHeight: '31px' };

class RadioValidationBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: [],
      valid: null,
      site: null,
      iccid: null,
      radio_billing: null,
      text: '',
      inputMode: false, // determines whether to show the input box or not.
      loading: false,
      selectedRadio: {},
    };
  }

  // set text and wipe the rest of the state
  onChange = event => {
    let text = event.target.value;
    text = text.replace(/[^a-z0-9]/gim, '').replace(/\s+/g, ' ');
    this.setState({
      text: text,
      errors: null,
      valid: null,
      site: null,
      iccid: null,
      radio_billing: null,
    });
  };

  enableInputMode = () => {
    const { radio, onInputMode } = this.props;
    if (typeof onInputMode === 'function') {
      onInputMode();
    }
    const iccid = radio.get('iccid', '');
    this.setState({ inputMode: true, text: iccid });
  };

  disableInputMode = () => this.setState({ inputMode: false });

  doLookup = () => {
    const { doRadioLookup } = this.props;
    const { text } = this.state;

    this.setState({ loading: true });

    doRadioLookup((text + '').trim())
      .then(res => {
        // swap iccid in for text in the event that it isn't null, this fixes the prefix problem.
        if (res.iccid != null) {
          res.text = res.iccid;
        }
        this.setState({ ...res });
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  onSave = () => {
    const { onRadioSelect } = this.props;
    const { radio_billing } = this.state;
    const radio = _.get(radio_billing, 'radio', null);
    if (radio != null) {
      onRadioSelect(Map(radio));
      this.disableInputMode();
    }
  };

  onCreateRadio = () => {
    const { createRadio } = this.props;
    const { iccid } = this.state;

    this.setState({
      loading: true,
    });

    createRadio({ iccid, mac_address: null })
      .then(res => {
        if (!_.has(res, 'error')) {
          // wipe the state
          this.setState({
            errors: [],
            valid: null,
            site: null,
            iccid: null,
            radio_billing: null,
          });
          // just do the lookup and let it find the radio
          this.doLookup();
        } else {
          // error out..
        }
      })
      .finally(() => {
        this.setState({
          loading: false,
        });
      });
  };

  render() {
    const { title, name, radio } = this.props;

    const { errors, valid, site, iccid, radio_billing, loading, inputMode } = this.state;

    const billedSiteGroup =
      _.get(radio_billing, 'billed_site_group', null) != null ? radio_billing.billed_site_group : null;
    const billedCustomer = billedSiteGroup != null ? _.get(billedSiteGroup, 'customer', null) : null;

    return (
      <div style={{ paddingTop: '5px', fontSize: '14px' }}>
        <div>
          <label style={{ margin: 0 }}>
            <b>{title}</b>
            <span style={{ fontSize: '12px' }}>
              {radio != null ? (
                inputMode ? (
                  <span
                    style={{ color: 'var(--md-primary)', cursor: 'pointer', marginLeft: '5px' }}
                    onClick={this.disableInputMode}
                  >
                    (cancel)
                  </span>
                ) : (
                  <span
                    style={{ color: 'var(--md-primary)', cursor: 'pointer', marginLeft: '5px' }}
                    onClick={this.enableInputMode}
                  >
                    (change)
                  </span>
                )
              ) : null}
            </span>
          </label>
        </div>
        {inputMode || radio == null ? (
          <div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <input
                type="text"
                name={name}
                onChange={this.onChange}
                value={this.state.text}
                style={{
                  height: '31px',
                  padding: '3px 7px',
                  borderRadius: 'var(--radius-md)',
                  border: '1px solid var(--border-default)',
                  borderTopColor: 'var(--border-default)',
                  width: '250px',
                  marginRight: '10px',
                }}
              />

              {!valid && (
                <Button
                  variant="contained"
                  color="primary"
                  disabled={this.state.text.trim().length < 14 || valid == false || loading}
                  onClick={this.doLookup}
                  style={buttonStyle}
                >
                  Validate
                </Button>
              )}
              {valid == true && radio_billing != null && (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.onSave}
                  disabled={loading}
                  style={buttonStyle}
                >
                  Confirm
                </Button>
              )}
              {valid == true && radio_billing == null && (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.onCreateRadio}
                  disabled={loading}
                  style={buttonStyle}
                >
                  Add Radio To system
                </Button>
              )}
            </div>
            <div style={{ fontSize: '13px', padding: '5px 0' }}>
              {valid == true && <div style={{ color: 'var(--status-ok)' }}>Valid ICCID</div>}
              {valid == true && radio_billing != null && <div> click "Confirm" to select this radio. </div>}
              {valid == null && (
                <div> Enter an ICCID above and press the "validate" button to check if it is valid.</div>
              )}
              {errors != null &&
                _.map(errors, (error, index) => (
                  <div key={index} style={{ color: 'var(--status-bad)' }}>
                    {error}
                  </div>
                ))}
              {radio_billing != null && billedCustomer != null && (
                <div>
                  Billed Customer: {billedCustomer.id} - {billedCustomer.name}
                </div>
              )}
              {radio_billing != null && billedSiteGroup != null && (
                <div>
                  Billed Plant: {billedSiteGroup.name} - {billedSiteGroup.description}
                </div>
              )}
              {radio_billing == null && valid == true && (
                <div>Radio not found in system, you will have to add it. </div>
              )}
              {site != null && (
                <div>
                  {' '}
                  On Active Site: {site.name} - {site.description}{' '}
                </div>
              )}
            </div>
          </div>
        ) : (
          <div style={{ margin: '4px 0 5px', width: '250px', borderBottom: '1px solid var(--border-default)' }}>
            <span> {radio.get('iccid', 'nope')} </span>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({
  doRadioLookup: iccid => dispatch(fetchRadioLookup(iccid)),
  createRadio: values => dispatch(createRadio(values)),
});

const RadioValidationBoxContainer = connect(mapStateToProps, mapDispatchToProps)(RadioValidationBox);

export default RadioValidationBoxContainer;
